module.exports = __webpack_public_path__ + "static/media/6.efa03be8.jpeg";